export class LoadSendEmailRequest {
  loadIds: Array<number> = new Array<number>();
  emailTo: string;
  emailCc: string;
}
